import { form, AppendixForm, AppendixForm1 } from "./form";

const checkout = form;
const checkoutAppendix = AppendixForm;
const checkoutAppendix1 = AppendixForm1;

const {
  formField: {
    taxId,
    conpanyName,
    releaseDate,
    representative,
    // address,
    lastTime,
    taxCalculationPeriod,
    changePosition,
    creator,
    sendTo,
  },
} = checkout;

const {
  formFieldAppendix: {
    taxIdAppendix,
    conpanyNameAppendix,
    releaseDateAppendix,
    representativeAppendix,
  },
} = checkoutAppendix;

const {
  formFieldAppendix1: {
    taxIdAppendix1,
    conpanyNameAppendix1,
    releaseDateAppendix1,
    representativeAppendix1,
  },
} = checkoutAppendix1;

const initialValues = {
  [taxId.name]: "",
  [conpanyName.name]: "",
  [releaseDate.name]: "",
  [representative.name]: "",
  [creator.name]: "",
  [lastTime.name]: "",
  [taxCalculationPeriod.name]: "",
  [changePosition.name]: "",
  [sendTo.name]: "",
};

export default initialValues;
